import { SHOP_STATE_KEY } from '../../action-types';

export const UPDATE_USER_LOCATION_DATA = `${SHOP_STATE_KEY}/UPDATE_USER_LOCATION_DATA`;

export default function locationReducer(state = {}, action = {}) {
  switch (action.type) {
    case UPDATE_USER_LOCATION_DATA:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
